/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CoordinatesSource {
  PIN_DROP="PIN_DROP",
LAT_LNG="LAT_LNG",
ADDRESS="ADDRESS"
}

/**
* CoordinatesSource
*/
export const CoordinatesSourceEnumType = types.enumeration("CoordinatesSource", [
        "PIN_DROP",
  "LAT_LNG",
  "ADDRESS",
      ])
